import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getCompleteData, getItems, getYears } from "../../../actions/HomeAction";
import Axios from "../../../axios/axios";

function BuildingAdvancedSearch({ onResults, currentParts, categoryId }) {
  const initialFilters = {
    year: "",
    regionId: "",
    brandId: "",
    modelId: "",
    features: "",
    application: "",
    subcategoryId: "", 
    categoryId: categoryId || "",
  };

  const [filters, setFilters] = useState(initialFilters);
  const [regions, setRegions] = useState([]);
  const [years, setYears] = useState([]);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "38px",
      borderRadius: "6px",
      borderColor: "#ced4da",
      marginBottom: "10px",
      fontSize: "14px",
    }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
  };

  useEffect(() => {
    getItems(setRegions);
    setYears(getYears());
    getCompleteData(setBrands, () => {}, setModels);

    Axios.get("/categories?type=building").then(res => {
      setCategories(res.data);
    });
  }, []);

  useEffect(() => {
    if (!categoryId || categories.length === 0) {
      setSubcategories([]);
      return;
    }
    const selectedCategory = categories.find(c => c._id === categoryId);
    if (selectedCategory?.subcategories?.length > 0) {
      setSubcategories(selectedCategory.subcategories);
    } else {
      setSubcategories([]);
    }
  }, [categoryId, categories]);

  useEffect(() => {
    if (onResults) onResults(filters);
  }, [filters]);

  const handleSelectChange = (name, selectedOption) => {
    const val = selectedOption ? selectedOption.value : "";
    setFilters((prev) => ({ ...prev, [name]: val }));
  };

  const clearFilters = () => {
    setFilters(initialFilters);
    if (onResults && currentParts) {
      onResults(currentParts);
    }
  };

  const subcategoryOptions = subcategories.map((sc) => ({ value: sc._id, label: sc.name }));
  const yearOptions = years.map((y) => ({ value: String(y), label: String(y) }));
  const regionOptions = regions.map((r) => ({ value: r._id, label: r.name }));
  const brandOptions = brands.map((b) => ({ value: b._id, label: b.name }));
  const modelOptions = models.map((m) => ({ value: m._id, label: m.name }));

  const featureOptions = [
    { value: "Weatherproof", label: "Weatherproof" },
    { value: "Fire Resistant", label: "Fire Resistant" },
    { value: "High Tensile", label: "High Tensile" },
    { value: "Eco Friendly", label: "Eco Friendly" },
    { value: "Heavy Duty", label: "Heavy Duty" },
    { value: "Thermal Insulation", label: "Thermal Insulation" },
  ];

  const applicationOptions = [
    { value: "Structural", label: "Structural" },
    { value: "Roofing", label: "Roofing" },
    { value: "Flooring", label: "Flooring" },
    { value: "Electrical", label: "Electrical" },
    { value: "Plumbing", label: "Plumbing" },
    { value: "Interior", label: "Interior" },
    { value: "Exterior", label: "Exterior" },
    { value: "Landscaping", label: "Landscaping" },
  ];

  return (
    <div className="container py-4">
      <h4 className="mb-3">Building Materials Advanced Search</h4>

      <button
        type="button"
        className="btn btn-sm btn-outline-danger w-100 mb-3 fw-bold"
        onClick={clearFilters}
      >
        Clear Filters
      </button>

      {subcategories.length > 0 && (
        <div className="mb-2">
          <Select
            isClearable
            isSearchable
            placeholder="Subcategory..."
            options={subcategoryOptions}
            value={subcategoryOptions.find(o => o.value === filters.subcategoryId) || null}
            onChange={(opt) => handleSelectChange("subcategoryId", opt)}
            styles={customSelectStyles}
          />
        </div>
      )}

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Year..."
          options={yearOptions}
          value={yearOptions.find(o => o.value === String(filters.year)) || null}
          onChange={(opt) => handleSelectChange("year", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Region..."
          options={regionOptions}
          value={regionOptions.find(o => o.value === filters.regionId) || null}
          onChange={(opt) => handleSelectChange("regionId", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Brand..."
          options={brandOptions}
          value={brandOptions.find(o => o.value === filters.brandId) || null}
          onChange={(opt) => handleSelectChange("brandId", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Model..."
          options={modelOptions}
          value={modelOptions.find(o => o.value === filters.modelId) || null}
          onChange={(opt) => handleSelectChange("modelId", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Features..."
          options={featureOptions}
          value={featureOptions.find(o => o.value === filters.features) || null}
          onChange={(opt) => handleSelectChange("features", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Application..."
          options={applicationOptions}
          value={applicationOptions.find(o => o.value === filters.application) || null}
          onChange={(opt) => handleSelectChange("application", opt)}
          styles={customSelectStyles}
        />
      </div>
    </div>
  );
}

export default BuildingAdvancedSearch;
